import { NbLayoutDirectionService, NbThemeService } from '@nebular/theme';
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { NbLayoutDirection } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
// import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  constructor(
    private analytics: AnalyticsService,
    private directionService: NbLayoutDirectionService,
    private themeService: NbThemeService,
      private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.analytics.trackPageViews();
    this.directionService.setDirection(NbLayoutDirection.RTL);
    this.themeService.changeTheme('corporate');
    if (this.directionService.getDirection() === NbLayoutDirection.RTL) this.translate.use('ar');
    else this.translate.use('en');
  }
}
